import { MaskReveal } from "../components/Reveal";
import { PHONE_DISPLAY, OFFICES } from "../data/constants";

const SECTIONS = [
  {
    n: "1",
    title: "Általános rendelkezések",
    body: [
      "A jelen Általános Szerződési Feltételek (a továbbiakban: ÁSZF) a Pénzügyi Megoldások (a továbbiakban: Szolgáltató) által nyújtott pénzügyi közvetítői és tanácsadói szolgáltatások igénybevételének feltételeit szabályozzák.",
      "A Szolgáltató tevékenysége kiterjed a következő területekre: hitelközvetítés, munkáshitel, biztosításközvetítés, CSOK (Családi Otthonteremtési Kedvezmény), Otthonstart program, Babaváró, valamint személyi kölcsön igénylésének elősegítése.",
      "Az ÁSZF a weboldal használatával, illetve az időpontfoglalás vagy visszahívás igénylésével automatikusan elfogadásra kerül.",
    ],
  },
  {
    n: "2",
    title: "A szolgáltatás tárgya",
    body: [
      "A Szolgáltató független pénzügyi tanácsadást és közvetítést nyújt. A tanácsadás célja, hogy az ügyfél a piacon elérhető ajánlatok közül a számára legmegfelelőbbet választhassa ki.",
      "A Szolgáltató nem hitelintézet és nem biztosító, hanem közvetítőként jár el az ügyfél és a pénzügyi intézmények között.",
      "A tanácsadás díjmentes; a Szolgáltató a közvetített intézményektől részesül díjazásban, amely az ügyfél számára nem jelent többletköltséget.",
    ],
  },
  {
    n: "3",
    title: "Időpontfoglalás és visszahívás",
    body: [
      "Az ügyfél a weboldalon keresztül időpontot foglalhat személyes tanácsadásra, illetve telefonos visszahívást kérhet.",
      "Az időpontfoglalás során megadott adatok (név, telefonszám, e-mail cím, választott iroda, időpont) kizárólag a szolgáltatás teljesítése céljából kerülnek felhasználásra.",
      "A foglalás visszaigazolása telefonon vagy e-mailben történik. A Szolgáltató fenntartja a jogot az időpont egyeztetésére vagy módosítására.",
    ],
  },
  {
    n: "4",
    title: "Hitel- és kölcsönközvetítés",
    body: [
      "A hitel-, munkáshitel-, személyi kölcsön-, Babaváró és Otthonstart konstrukciókra vonatkozó tanácsadás nem minősül konkrét ajánlattételnek. A végleges hitelbírálat és folyósítás minden esetben az adott pénzügyi intézmény hatáskörébe tartozik.",
      "A Szolgáltató nem vállal felelősséget a pénzügyi intézmény által hozott döntésekért, illetve a hitelbírálat eredményéért.",
      "Az ügyfél felelőssége a megadott adatok valóságtartalma és teljessége.",
    ],
  },
  {
    n: "5",
    title: "Biztosításközvetítés, CSOK és otthonteremtési konstrukciók",
    body: [
      "A biztosítási termékekre vonatkozó tanácsadás a mindenkori piaci ajánlatok alapján történik. A szerződés a kiválasztott biztosítóval jön létre.",
      "A CSOK, az Otthonstart, a Babaváró és a Munkáshitel igénybevételének feltételeit a mindenkor hatályos jogszabályok határozzák meg. A Szolgáltató a jogszabályi feltételek felmérésében és az igénylésben nyújt segítséget.",
      "A kedvezmények és konstrukciók jóváhagyása az illetékes hatóság, illetve pénzügyi intézmény kizárólagos jogköre.",
    ],
  },
  {
    n: "6",
    title: "Adatkezelés",
    body: [
      "A Szolgáltató az ügyfél személyes adatait az Európai Unió Általános Adatvédelmi Rendelete (GDPR) és a vonatkozó magyar jogszabályok szerint kezeli.",
      "Az adatok kizárólag a szolgáltatás nyújtásához szükséges mértékben és ideig kerülnek felhasználásra, harmadik félnek csak az ügyfél hozzájárulásával, a közvetítés céljából adhatók át.",
      "Az ügyfél bármikor kérheti adatai módosítását vagy törlését az elérhetőségeinken keresztül.",
    ],
  },
  {
    n: "7",
    title: "Felelősség korlátozása",
    body: [
      "A Szolgáltató mindent megtesz a naprakész és pontos tájékoztatásért, azonban nem vállal felelősséget a jogszabályi változásokból vagy a pénzügyi intézmények feltételeinek módosulásából eredő eltérésekért.",
      "A weboldalon szereplő információk tájékoztató jellegűek, és nem minősülnek kötelező érvényű ajánlatnak.",
    ],
  },
  {
    n: "8",
    title: "Záró rendelkezések",
    body: [
      "A jelen ÁSZF-ben nem szabályozott kérdésekben a Polgári Törvénykönyv és a vonatkozó magyar jogszabályok az irányadók.",
      "A Szolgáltató fenntartja a jogot az ÁSZF egyoldalú módosítására. A módosított feltételek a weboldalon való közzététellel lépnek hatályba.",
    ],
  },
];

export default function Aszf() {
  return (
    <div data-testid="aszf-page" className="pt-40">
      <section className="mx-auto max-w-[1400px] px-6 lg:px-10 pb-16 border-b border-border">
        <span className="overline text-muted-foreground">Jogi információ</span>
        <h1 className="font-serif-display font-medium tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl mt-6">
          <MaskReveal lines={["Általános Szerződési", "Feltételek"]} delay={0.2} />
        </h1>
        <p className="text-muted-foreground mt-6 max-w-xl">
          Hatályos: {new Date().getFullYear()}. Kérjük, figyelmesen olvassa el a szolgáltatásaink
          igénybevételére vonatkozó feltételeket.
        </p>
      </section>

      <section className="mx-auto max-w-3xl px-6 lg:px-10 py-20">
        <div className="space-y-16">
          {SECTIONS.map((s) => (
            <div key={s.n} data-testid={`aszf-section-${s.n}`} className="grid grid-cols-[auto_1fr] gap-6">
              <span className="font-serif-display text-3xl text-muted-foreground/50">{s.n}</span>
              <div>
                <h2 className="font-serif-display text-2xl tracking-tight">{s.title}</h2>
                <div className="mt-5 space-y-4">
                  {s.body.map((p, i) => (
                    <p key={i} className="text-muted-foreground leading-relaxed text-[15px]">{p}</p>
                  ))}
                </div>
              </div>
            </div>
          ))}

          <div className="border-t border-border pt-10">
            <h2 className="font-serif-display text-2xl tracking-tight">Elérhetőség</h2>
            <p className="text-muted-foreground mt-4">Telefon: {PHONE_DISPLAY}</p>
            <ul className="mt-3 space-y-1 text-muted-foreground text-[15px]">
              {OFFICES.map((o) => (
                <li key={o.id}>{o.address}</li>
              ))}
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
}
